import { render, staticRenderFns } from "./DispatchPlaceholder.vue?vue&type=template&id=bb692c34&scoped=true&"
import script from "./DispatchPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DispatchPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./DispatchPlaceholder.vue?vue&type=style&index=0&id=bb692c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb692c34",
  null
  
)

export default component.exports